module.exports = __webpack_public_path__ + "img/Man5-Dora.d30d7b1c.png";